<div class="modal-header">
  <h5 class="modal-title" i18n>Copy Fees To</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <mat-stepper [linear]="true" #stepper>
    <mat-step label="Select Fees to Copy to" i18n-label [completed]="!!selectedFees.length">
      <app-select-fees-table
        [selectedRentalIds]="[rental.id]"
        (selected)="onSelectFees($event)"
      ></app-select-fees-table>
    </mat-step>
    <mat-step label="Select Rentals to Copy to" i18n-label [completed]="!!selectedRentals.length">
      <app-select-rentals-table
        [excludedRentalIds]="[rental.id]"
        (selected)="onSelectRentals($event)"
      ></app-select-rentals-table>
    </mat-step>
    <ng-template matStepperIcon="edit">
      <i class="cs-icon cs-icon-check"></i>
    </ng-template>
    <ng-template matStepperIcon="done">
      <i class="cs-icon cs-icon-check"></i>
    </ng-template>
  </mat-stepper>
  <div *ngIf="isLoading">
    <div class="text-right">
      <i class="far fa-spin fa-spinner mr-1 text-primary"></i>
      {{ progress }}/{{ selectedRentals.length }}
    </div>
    <mat-progress-bar mode="determinate" [value]="(progress / selectedRentals.length) * 100"></mat-progress-bar>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-light" (click)="stepper.previous()" *ngIf="stepper.selectedIndex > 0">
    <i class="far fa-arrow-left"></i> <ng-container i18n>Back</ng-container>
  </button>
  <button class="btn btn-outline-light" (click)="stepper.next()" *ngIf="stepper.selectedIndex < 1">
    <ng-container i18n>Next</ng-container> <i class="far fa-arrow-right"></i>
  </button>

  <ng-container *ngIf="stepper.selectedIndex === 1">
    <button
      class="btn btn-secondary-success"
      [disabled]="!selectedFees.length || !selectedRentals.length || isLoading"
      (click)="onOverwrite()"
      matTooltip="It will replace your current settings"
      i18n-matTooltip
    >
      <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
      <ng-container i18n>Overwrite</ng-container>
    </button>
    <button
      class="btn btn-secondary-info"
      [disabled]="!selectedFees.length || !selectedRentals.length || isLoading"
      (click)="onAdd()"
      matTooltip="Selected settings will be added to your rental"
      i18n-matTooltip
    >
      <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
      <ng-container i18n>Copy</ng-container>
    </button>
  </ng-container>
</div>
